<template>
    <div class="welcome-message flex items-center justify-start">
        <div class="rounded-xl bg-white flex flex-col gap-6">

            <div class="flex flex-col gap-3">
                <p class="text-sm text-black font-semibold flex items-center gap-2">
                    <PtIcon icon="Copilot" class="text-2xl shrink-0" />
                    {{ t('chat.WelcomeMessage.title') }}
                </p>
                <p class="text-sm text-[#020a1a]" v-safe-html="t('chat.WelcomeMessage.content')"/>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { PtIcon } from 'patsnap-biz'
import { useI18n } from 'vue-i18n'

import '@/assets/icon/suggest.svg'
import '@patsnap-ui/icon/assets/solid/send.svg';
import '@/assets/icon/copilot.svg'

const { t } = useI18n();
</script>
